import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { db } from './firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const SubscriptionContext = createContext();

export function useSubscription() {
    return useContext(SubscriptionContext);
}

export function SubscriptionProvider({ children }) {
    const { currentUser } = useAuth();
    const [subscription, setSubscription] = useState('none'); // implicit: niciun pachet
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadSubscription = async () => {
            if (!currentUser) {
                setLoading(false);
                return;
            }
            try {
                const docRef = doc(db, 'userResponses', currentUser.uid);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    const data = docSnap.data();
                    // Dacă există deja subscription, îl folosim; altfel setăm 'none'
                    setSubscription(data.subscription || 'none');
                    // Dacă nu există câmpul subscription, îl adăugăm cu 'none'
                    if (!data.subscription) {
                        await setDoc(docRef, { subscription: 'none' }, { merge: true });
                    }
                } else {
                    // Nu există documentul, îl creăm cu subscription: 'none'
                    await setDoc(docRef, { subscription: 'none' });
                    setSubscription('none');
                }
            } catch (error) {
                console.error('Eroare la încărcarea abonamentului:', error);
            } finally {
                setLoading(false);
            }
        };
        loadSubscription();
    }, [currentUser]);

    // Funcție pentru actualizarea abonamentului (ex: după plată reușită)
    const updateSubscription = async (newSubscription) => {
        if (!currentUser) return;
        try {
            const docRef = doc(db, 'userResponses', currentUser.uid);
            await setDoc(docRef, { subscription: newSubscription }, { merge: true });
            setSubscription(newSubscription);
        } catch (error) {
            console.error('Eroare la actualizarea abonamentului:', error);
        }
    };

    const value = {
        subscription,
        loading,
        updateSubscription,
        isPremium: subscription === 'premium',
        isStandard: subscription === 'standard',
        hasSubscription: subscription !== 'none',
    };

    return (
        <SubscriptionContext.Provider value={value}>
            {children}
        </SubscriptionContext.Provider>
    );
}